"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FilterDateRange = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDateRange = require("react-date-range");

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FixedRanges = _interopRequireDefault(require("./FixedRanges.js"));

var _DatePickerStyle = _interopRequireDefault(require("./DatePickerStyle.js"));

var _styled = require("./styled.js");

var _IntervalFromCustomRange = _interopRequireDefault(require("./IntervalFromCustomRange"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var API_DATE_FORMAT = 'YYYY-MM-DD';
/**
 * @desc wrapper around react-date-range, updates FilterManager's state
 * we initialize the startDate and endDate in scenarios where the component
 * is receiving these values as props, such as from a set of filters.
 * these are placed within the constructor to prevent the over updating
 * the state from subsequent date selections being passed down.
 */

var FilterDateRange =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterDateRange, _Component);

  function FilterDateRange(props) {
    var _this;

    _classCallCheck(this, FilterDateRange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FilterDateRange).call(this, props));
    _this.state = {
      start: props.startDate ? (0, _moment["default"])(props.startDate) : null,
      end: props.endDate ? (0, _moment["default"])(props.endDate) : null,
      open: false,
      intervalSelected: props.startDate && props.endDate ? 'custom' : 'lastYear',
      clickCount: 0
    };

    _this.boundChildOfRange = function (e) {
      return _this.isChildOfRange(e);
    };

    _this.dateNow = (0, _moment["default"])();
    return _this;
  }
  /**
   * @desc check if a click event is coming from the body
   */


  _createClass(FilterDateRange, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      window.addEventListener('click', this.boundChildOfRange, false);
    }
    /**
     * @desc remove the event listening for clicks on the body on unmount
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.boundChildOfRange, false);
    }
    /**
     * @desc used for our fixed ranges, where the timeInterval is specified
     * & the
     * @param {Object} dates
     */

  }, {
    key: "setRange",
    value: function setRange(startDate, endDate, timeInterval) {
      var start = startDate.format(API_DATE_FORMAT);
      var end = endDate.format(API_DATE_FORMAT);
      this.props.update({
        pageNum: 1,
        startDate: start,
        endDate: end,
        timeInterval: timeInterval
      });
      this.setState({
        start: startDate,
        end: endDate,
        intervalSelected: timeInterval
      });
    }
    /**
     * @desc Adapted to use the data returned by the third party date picker.
     * updates the local state to display the values in the start/end filter
     * divs, and updates FilterManager's state through the passed down method.
     * this is the callback from the date range selection.
     * @param {Object} dates
     */

  }, {
    key: "customRange",
    value: function customRange(dates, _ref) {
      var init = _ref.init;
      var clickCount = this.state.clickCount;
      clickCount++;
      var open = dates.startDate === dates.endDate;
      var interval = (0, _IntervalFromCustomRange["default"])(dates);
      this.setState({
        intervalSelected: interval,
        open: open,
        clickCount: clickCount
      }); // only trigger custom range if 2 dates have been selected

      if (init || clickCount === 2) {
        this.setRange(dates.startDate, dates.endDate, interval);
      }
    }
    /**
     * @desc hides the date range container when the user clicks outside of it
     */

  }, {
    key: "isChildOfRange",
    value: function isChildOfRange(event) {
      if (this.root && !this.root.contains(event.target)) {
        this.setState({
          open: false
        });
      }
    }
    /**
     * @desc requests visitors aggregates for today
     */

  }, {
    key: "range",
    value: function range(intervalSelected) {
      var _FIXED_RANGES$interva = _FixedRanges["default"][intervalSelected],
          start = _FIXED_RANGES$interva.start,
          end = _FIXED_RANGES$interva.end,
          timeInterval = _FIXED_RANGES$interva.timeInterval;
      this.setRange(start(), end(), timeInterval);
      this.setState({
        intervalSelected: intervalSelected,
        open: false
      });
    }
  }, {
    key: "isSelected",
    value: function isSelected(range) {
      return this.state.intervalSelected === range ? 'selected' : '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var themed = this.props.themed;
      var _this$state = this.state,
          start = _this$state.start,
          end = _this$state.end,
          open = _this$state.open,
          intervalSelected = _this$state.intervalSelected;

      var dateRangeStart = start || _FixedRanges["default"][intervalSelected].start();

      var dateRangeEnd = end || _FixedRanges["default"][intervalSelected].end();

      var ranges = Object.keys(_FixedRanges["default"]);
      return _react["default"].createElement(_styled.FilterContainer, {
        ref: function ref(el) {
          _this2.root = el;
        },
        themed: themed
      }, _react["default"].createElement("div", {
        className: "filterItem start",
        onClick: function onClick() {
          return _this2.setState({
            open: true,
            clickCount: 0
          });
        }
      }, dateRangeStart.format(API_DATE_FORMAT) || 'START'), _react["default"].createElement("span", {
        className: "arrow"
      }, "\u2B62"), _react["default"].createElement("div", {
        className: "filterItem end",
        onClick: function onClick() {
          return _this2.setState({
            open: true,
            clickCount: 0
          });
        }
      }, dateRangeEnd.format(API_DATE_FORMAT) || 'END'), _react["default"].createElement("div", {
        className: "rangeContainer filterBox ".concat((0, _classnames["default"])({
          open: open
        }))
      }, _react["default"].createElement("div", {
        className: "rangeShortcuts"
      }, ranges.map(function (fixedRange) {
        return _react["default"].createElement("div", {
          className: "rangeOption ".concat(fixedRange, " ").concat(_this2.isSelected(fixedRange)),
          onClick: function onClick() {
            return _this2.range(fixedRange);
          },
          key: fixedRange
        }, _FixedRanges["default"][fixedRange].text);
      })), _react["default"].createElement(_reactDateRange.DateRange, {
        format: API_DATE_FORMAT,
        startDate: dateRangeStart,
        endDate: dateRangeEnd,
        onInit: function onInit(d) {
          return _this2.customRange(d, {
            init: true
          });
        },
        onChange: function onChange(d) {
          return _this2.customRange(d, {
            init: false
          });
        },
        linkedCalendars: true,
        theme: _DatePickerStyle["default"]
      })));
    }
  }]);

  return FilterDateRange;
}(_react.Component);

exports.FilterDateRange = FilterDateRange;
var _default = FilterDateRange;
exports["default"] = _default;

//# sourceMappingURL=FilterDateRange.js.map